/**
 * @generated SignedSource<<aec625eb8d10dac10d8b75f45f93e968>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useContentTypesTitleUpdateContentTitleWriteFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "useContentTypesTitleUpdateContentTitleWriteFragment";
};
export type useContentTypesTitleUpdateContentTitleWriteFragment$key = {
  readonly " $data"?: useContentTypesTitleUpdateContentTitleWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentTypesTitleUpdateContentTitleWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "3d624df929b7f5b6bedfdab8b98fb427";

export default node;
